module.exports = __webpack_public_path__ + "static/media/temperature-low.7461b5a3.svg";